import { Field } from 'formik';
import { SITUACAO } from '../constantes';
import { SttFormControl, SttFormGroup, SttFormControlLabel, SttCheckbox } from '@stt-componentes/core';
import { SITUACAO_EXAME, DATA_INVALIDACAO_DE, DATA_INVALIDACAO_ATE, DATA_LAUDO_DE, DATA_LAUDO_ATE } from '../fieldNames';

const SituacaoExame = ({ strings }) => {
    return (
        <>
           <Field name={SITUACAO_EXAME}>
                {({
                    field,
                    form
                }) => (
                    <SttFormControl variant="outlined">
                        <SttFormGroup row>
                            <SttFormControlLabel
                                control={
                                    <SttCheckbox
                                        {...field}
                                        value={SITUACAO.VALIDO}
                                        color="primary"
                                        checked={form.values[SITUACAO_EXAME].includes(SITUACAO.VALIDO)}
                                    />
                                }
                                label={strings.valido}
                            />
                            <SttFormControlLabel
                                control={
                                    <SttCheckbox
                                        {...field}
                                        value={SITUACAO.INVALIDO}
                                        color="primary"
                                        checked={form.values[SITUACAO_EXAME].includes(SITUACAO.INVALIDO)}
                                        onChange={event => {
                                            field.onChange(event);
                                            if (!event.target.checked) {
                                                form.setFieldValue(DATA_INVALIDACAO_DE, null);
                                                form.setFieldValue(DATA_INVALIDACAO_ATE, null);
                                            } else {
                                                form.setFieldValue(DATA_LAUDO_DE, null);
                                                form.setFieldValue(DATA_LAUDO_ATE, null);
                                            }
                                        }}
                                    />
                                }
                                label={strings.invalido}
                            />
                        </SttFormGroup>
                    </SttFormControl>
                )}
            </Field>
        </>
    )
};

export default SituacaoExame;